import { render, staticRenderFns } from "./FileSelectBox.vue?vue&type=template&id=06931551&scoped=true"
import script from "./FileSelectBox.vue?vue&type=script&lang=js"
export * from "./FileSelectBox.vue?vue&type=script&lang=js"
import style0 from "./FileSelectBox.vue?vue&type=style&index=0&id=06931551&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06931551",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/6888b5b9-9128-43f9-bb48-628a7d9749d7/workspace/Knowledge-base_jo8K/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06931551')) {
      api.createRecord('06931551', component.options)
    } else {
      api.reload('06931551', component.options)
    }
    module.hot.accept("./FileSelectBox.vue?vue&type=template&id=06931551&scoped=true", function () {
      api.rerender('06931551', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/cloud-disk/src/views/FileSelectBox.vue"
export default component.exports